'use client';

import { Link, usePathname } from '@/app/(webapp)/_i18n/navigation';
import { CatalogMenuLabelEnum } from '@/app/(webapp)/_types';
import { useTranslations } from 'next-intl';
import {
    NAVIGATION_ACTIVE_ITEM_CLASS,
    NAVIGATION_ITEM_CLASS,
    NAVIGATION_LAST_ITEM_CLASS,
    NavigationDropDown,
} from '../navigation-dropdown';
import type { CatalogDropDownProps, CatalogMenuItem, CatalogRoute } from './interfaces';

const MENU_ITEMS: ReadonlyArray<{ id: CatalogMenuLabelEnum; translationKey: string; href: CatalogRoute }> = [
    { id: CatalogMenuLabelEnum.YOUR_PROGRAMS, translationKey: 'catalog.programs', href: '/dashboard-programs' },
    { id: CatalogMenuLabelEnum.YOUR_FORMATS, translationKey: 'catalog.formats', href: '/dashboard-formats' },
];

export const CatalogDropDown = ({ callback, autoExpand }: CatalogDropDownProps) => {
    const t = useTranslations('Navigation.seller');
    const pathname = usePathname();
    const getActiveMenuFromPath = (): CatalogMenuLabelEnum | undefined => {
        if (pathname.includes('/dashboard-programs')) return CatalogMenuLabelEnum.YOUR_PROGRAMS;
        if (pathname.includes('/dashboard-formats')) return CatalogMenuLabelEnum.YOUR_FORMATS;
        return undefined;
    };

    const activeMenuItem = getActiveMenuFromPath();
    const menuItemConfigs = MENU_ITEMS;
    const translateDynamicKey = t as (key: string) => string;

    const menuItems: CatalogMenuItem[] = menuItemConfigs.map((item) => ({
        id: item.id,
        label: translateDynamicKey(item.translationKey),
        href: item.href,
    }));

    return (
        <NavigationDropDown
            label={t('catalog.label')}
            isActive={!!activeMenuItem}
            autoOpen={autoExpand && !!activeMenuItem}
            panelClassName="max-h-[440px] sm:max-h-[initial] overflow-y-auto"
        >
            {(close) =>
                menuItems.map((item, index, array) => (
                    <li key={item.id}>
                        <Link
                            className={`${activeMenuItem === item.id ? NAVIGATION_ACTIVE_ITEM_CLASS : `whitespace-nowrap ${NAVIGATION_ITEM_CLASS}`} ${index === array.length - 1 ? NAVIGATION_LAST_ITEM_CLASS : ''}`}
                            onClick={() => {
                                callback();
                                close();
                            }}
                            href={item.href}
                        >
                            <span>{item.label}</span>
                        </Link>
                    </li>
                ))
            }
        </NavigationDropDown>
    );
};
